export default {
  colors: {
    primary: '#00457C',
    secondary: '#CAD400',
  },
}
